export enum StockCheckStatus {
    Counting = 1,
    Completed = 2,
    Pending = 3,
    PendingApproval = 4,
  }